import {renderMakeResponse, renderUserPrompt} from './renderers.js';
import {longPoll} from '../poll.js';
import {RESPONSE_ID_PREFIX} from './constants.js';
import {resetFormLoading} from '../formSubmit.js';
import {scrollToBottom} from '../../../../components/kui/layouts/chat/chat_log.js';
import {KindeSSEClient} from './websocket-client.js';

const togglePromptButtons = (
    submitButtonEl,
    containerEl,
    isShowStop = false
) => {
    const stopButtonEl = containerEl.querySelector(
        '[data-kui-chat-prompt-stop-button]'
    );

    if (!stopButtonEl) {
        return {submitButtonEl, stopButtonEl: null};
    }

    submitButtonEl.style.display = isShowStop ? 'none' : 'inline-flex';
    stopButtonEl.style.display = isShowStop ? 'inline-flex' : 'none';

    return {submitButtonEl, stopButtonEl};
};

const setupStopButton = (submitButtonEl, containerEl) => {
    const {stopButtonEl} = togglePromptButtons(
        submitButtonEl,
        containerEl,
        true
    );

    stopButtonEl.onclick = () => {
        longPoll.cancel();
        makeHandler({
            event: 'end',
            message: 'Stopped by user'
        });
    };
};

const makeHandler = async (res) => {
    const {event} = res;
    const chatLogContainerEl = document.querySelector('[data-kui-chat-log]');
    const promptContainerEl = document.querySelector('[data-kui-chat-prompt]');

    if (!chatLogContainerEl || !promptContainerEl) {
        console.warn('Required chat container elements not found');
        return;
    }

    const formSubmitBtnEl = promptContainerEl.querySelector(
        'button[type="submit"]'
    );
    const promptInputEl = promptContainerEl.querySelector('textarea');

    if (!promptInputEl || !formSubmitBtnEl) {
        console.warn('Required chat prompt elements not found');
        return;
    }

    switch (event) {
        case 'start': {
            const {job_id, project_id, prompt} = res;

            // Clear the input field
            promptInputEl.value = '';

            // Render user prompt first
            await renderUserPrompt(prompt, chatLogContainerEl);

            // Setup stop button
            setupStopButton(formSubmitBtnEl, promptContainerEl);

            // Append form data
            const formData = new FormData();
            formData.append('p_job_id', job_id);
            formData.append('project_id', project_id);

            // Start polling - can be cancelled by stop button
            longPoll(
                '/make/progress',
                formData,
                renderMakeResponse(job_id, chatLogContainerEl)
            );

            break;
        }
        case 'failure':
        case 'end': {
            // Finalise any active streaming renderers
            const activeRenderers = chatLogContainerEl.querySelectorAll(
                `[id^="${RESPONSE_ID_PREFIX}"]`
            );
            activeRenderers.forEach((responseEl) => {
                if (responseEl._streamingRenderer) {
                    responseEl._streamingRenderer.finalize();
                }
            });

            formSubmitBtnEl.disabled = true;
            promptInputEl.value = '';
            promptInputEl.focus();
            resetFormLoading(formSubmitBtnEl);
            togglePromptButtons(formSubmitBtnEl, promptContainerEl, false);
            scrollToBottom(chatLogContainerEl);

            break;
        }
        default: {
            break;
        }
    }
};

const initializeWebSocket = () => {
    // Get session ID from the page context
    const sessionIdElement = document.querySelector('[data-session-id]');

    if (sessionIdElement) {
        const sessionId = sessionIdElement.dataset.sessionId;
        console.log('Session ID value:', sessionId);

        if (sessionId) {
            console.log('Initializing WebSocket with session ID:', sessionId);

            // Initialize WebSocket client
            window.kindeWebSocket = new KindeWebSocketClient(sessionId);

            // Clean up on page unload
            window.addEventListener('beforeunload', function () {
                if (window.kindeWebSocket) {
                    window.kindeWebSocket.disconnect();
                }
            });
        } else {
            console.warn('No session ID available for WebSocket connection');
            console.log(
                'Session ID element attributes:',
                sessionIdElement.attributes
            );
            console.log(
                'Session ID element innerHTML:',
                sessionIdElement.innerHTML
            );
        }
    } else {
        console.warn('Session ID element not found');
    }
};

const initializeSSE = () => {
    // Get session ID from the page context
    const sessionIdElement = document.querySelector('[data-session-id]');

    if (sessionIdElement) {
        const sessionId = sessionIdElement.dataset.sessionId;
        console.log('Session ID value:', sessionId);

        if (sessionId) {
            console.log('Initializing SSE with session ID:', sessionId);

            // Initialize SSE client
            window.kindeSSE = new KindeSSEClient(sessionId);

            // Clean up on page unload
            window.addEventListener('beforeunload', function () {
                if (window.kindeSSE) {
                    window.kindeSSE.disconnect();
                }
            });
        } else {
            console.warn('No session ID available for SSE connection');
            console.log(
                'Session ID element attributes:',
                sessionIdElement.attributes
            );
            console.log(
                'Session ID element innerHTML:',
                sessionIdElement.innerHTML
            );
        }
    } else {
        console.warn('Session ID element not found');
    }
};

export {makeHandler, initializeWebSocket, initializeSSE};
